<cwc-modal id="remove-products-modal" [open]="true" [rtl]="rtl" (cwcClose)="closeModal()" [overlayZIndex]="1005" designVersion="v2" [closeOnBdClick]="false"
  [showCloseBtn]="false">
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div class="cmx-modal__section d-flex flex-column justify-content-center align-items-center">
      <cwc-icon name="warning-rounded-fill" size="100px" color="bright-orange" designVersion="v2"></cwc-icon>
      <h2 class="text-center">
        {{ 'views.pump-primer.remove-products.warning.header.text' | translate }}
      </h2>
      <h3 class="text-center">
        {{ 'views.pump-primer.remove-products.warning.body.text' | translate }}
      </h3>
    </div>
  </div>
  <footer slot="footer" class="alert-dialog__footer">
    <cwc-button (cwcClick)="acceptReset()" [rtl]="rtl" designVersion="v2">{{ 'views.pump-primer.remove-products.button.continue' | translate }}</cwc-button>
    <cwc-button (cwcClick)="cancelReset()" variant="support" [rtl]="rtl" designVersion="v2">{{
      'views.common.cancel' | translate
    }}</cwc-button>
  </footer>
</cwc-modal>